<template>
  <div class="result-dialog-wrap">
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      @closed="handleClosed"
      width="600px"
    >
      <div class="content">
        <template v-if="multi">
          <p>当前批量铺货数：{{ total }}</p>
          <div class="content-p" v-if="result['1'].length">
            <p>未维护外部商品信息：{{result['1'].map(({outerId}) => outerId).join('，')}}</p>
            <p>由于平台要求，需要进行外部商品信息关联设置，请先在基础资料中对宝贝链接及商品的价格进行维护；否则可能会导致铺货异常，平台处罚</p>
          </div>
          <div class="content-p" v-if="result['2'].length">
            <p>未以下商品铺货价高于历史铺货到其他平台的价格：{{result['2'].map(({outerId, lowerPrice}) => `${outerId}(${lowerPrice})`).join('，')}}</p>
            <p>括号内为该商品在历史其他平台的铺货价，建议您修改拼单价小于该价格</p>
          </div>
          <div class="content-p" v-if="result['3'].length">
            <p style="white-space: pre-wrap">存在其他异常：<br>{{result['3'].map(({outerId, msg}) => `${outerId}(${msg})`).join('\n')}}</p>
            <p>括号内为该商品在历史其他平台的铺货价，建议您修改拼单价小于该价格</p>
          </div>
        </template>
        <template v-else>
          <p v-if="mode === 1">由于平台要求，需要进行外部商品信息关联设置，请先在基础资料中对宝贝链接及商品的价格进行维护；否则可能会导致铺货异常，平台处罚</p>
          <p v-if="mode === 2">
            当前铺货商品的拼单价高于历史铺货记录中铺货到其他平台的价格（{{ result[result.single][0].lowerPrice }}），建议您修改拼单价小于该价格
          </p>
          <p v-if="mode === 6">其他异常：{{ result[result.single][0].msg }}</p>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <template v-if="this.multi">
          <el-button @click="handleCancel">{{ cancelText }}</el-button>
        </template>
        <template v-else>
          <el-button @click="handleCancel">{{ cancelText }}</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      result: {
        0: [],
        1: [],
        2: [],
        3: [],
        single: 0
      },
      resolve: null,
      multi: false,
      total: 0,
      singleAllClose: false,
      res: {
        type: "close"
      }
    };
  },
  computed: {
    mode() {
      // 弹窗的模式，根据数据来
      // 1 - 单个校验，无外部商品信息
      // 2 - 单个校验，商品信息价格大于外部商品信息价格
      // 3 - 批量校验，无外部商品信息
      // 4 - 批量校验，商品信息价格大于外部商品信息价格
      // 5 - 批量校验，3与4都包含
      // 6 - 单个校验，其他异常
      if (!this.multi) {
        if (this.result.single === 1) {
          return 1
        } else if (this.result.single === 2) {
          return 2
        } else if (this.result.single === 3) {
          return 6
        } else {
          return 0
        }
      } else {
        let has0 = !!this.result['0'].length;
        let has1 = !!this.result['1'].length;
        let has2 = !!this.result['2'].length;
        let has3 = !!this.result['3'].length;
        let hasNum = [has1, has2, has3].filter(Boolean).length;
        if (!has0) {
          return -1
        } else if (hasNum === 2) {
          return 8
        } else if (hasNum === 3) {
          return 5
        } else if (this.result['1'].length) {
          return 3
        } else if (this.result['2'].length) {
          return 4
        } else if (this.result['3'].length) {
          return 7
        } else {
          return 0
        }
      }
    },
    cancelText() {
      switch(this.mode) {
        case 1: return this.singleAllClose ? '关闭' : '去修改';
        case 2: return this.singleAllClose ? '关闭' : '修改';
        case 3: return '仅铺货已维护商品';
        case 4: return '仅铺货满足价格建议商品';
        case 8:
        case 5: return '仅铺货满足条件商品';
        case -1: 
        case 6: return '关闭';
        case 7: return '仅铺货无其他异常商品'
        default: return '';
      }
    }
  },
  methods: {
    handleClosed() {
      this.resolve && this.resolve({
        ...this.res
      })

      Object.entries(this.$options.data()).forEach(([key, val]) => {
        this[key] = val
      })
    },
    method_open(data, singleAllClose) {
      return new Promise((resolve) => {
        this.resolve = resolve;
        this.singleAllClose = singleAllClose;
        this.total = data.length;
        this.multi = this.total > 1;
        this.initData(data);
        this.dialogVisible = true;
      })
     
      
    },
    initData(data) {
      if (!this.multi) {
        this.result.single = data[0].state
        this.result[data[0].state] = [data[0]]
      } else {
        data.forEach(element => {
          this.result[element.state].push(element)
        });
      }
    },
    handleCancel() {
      if (!this.multi) {
        // 单个校验
        this.res = this.singleAllClose ? {
          type: 'close'
        } : this.mode === 1 ? {
          type: 'toBase'
        } : this.mode === 2 ? {
          type: 'toPdd'
        } : {
          type: 'close'
        }
      } else {
        // 批量校验
        if ([-1, 6].includes(this.mode)) {
          this.res = {
            type: 'close'
          }
        } else {
          this.res = {
            type: 'pubSome',
            data: this.result['0'].map(({baseItemId}) => baseItemId)
          }
        }
      }
      this.dialogVisible = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  color: red;
  .content-p + .content-p {
    margin-top: 20px;
  }
}
.item {
  padding-bottom: 20px;
}
</style>
